import { ReactNode, useCallback, useEffect, useState } from 'react'

import { registerMobileFloorMapUnavailableModal } from '../../../utils/mobileFloorMapModalController'

import { MobileFloorMapUnavailableModal } from './MobileFloorMapUnavailableModal'

interface MobileFloorMapUnavailableProviderProps {
  children: ReactNode
}

export const MobileFloorMapUnavailableProvider = ({
  children,
}: MobileFloorMapUnavailableProviderProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const showModal = useCallback(() => {
    setIsOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setIsOpen(false)
  }, [])

  useEffect(() => {
    registerMobileFloorMapUnavailableModal(showModal)
    return () => registerMobileFloorMapUnavailableModal(null)
  }, [showModal])

  return (
    <>
      {children}
      <MobileFloorMapUnavailableModal isOpen={isOpen} onClose={closeModal} />
    </>
  )
}
